import React from "react";
import { Form, Card } from "antd";

import {
  EditFormProps,
  Container,
  WidgetTitleFormField,
  SignalSelectorList,
} from "../../WidgetEditForm";
import { Config } from ".";

function sanitizeInputs(c: Config): Config {
  return {
    title: c.title,
    signals: c.signals.filter((s) => !!s),
    type: "text",
  };
}

const EditForm: React.FC<EditFormProps> = (props) => {
  return (
    <div className="text-widget-edit-form">
      <Form
        onFinish={(values) => props.onFinish(sanitizeInputs(values as Config))}
        layout="vertical"
        form={props.form}
        initialValues={props.config}
      >
        <Card title="Text Widget Settings">
          <WidgetTitleFormField />
          <SignalSelectorList max={10} signals={props.template.signals} rules= {[]} isColor={"color"}/>
        </Card>
      </Form>
    </div>
  );
};

export default EditForm;
